/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NpiResponseEnumerationType } from './NpiResponseEnumerationType';
import {
    NpiResponseEnumerationTypeFromJSON,
    NpiResponseEnumerationTypeFromJSONTyped,
    NpiResponseEnumerationTypeToJSON,
} from './NpiResponseEnumerationType';

/**
 * 
 * @export
 * @interface ValidatePalNpiRequest
 */
export interface ValidatePalNpiRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatePalNpiRequest
     */
    npi: string;
    /**
     * 
     * @type {string}
     * @memberof ValidatePalNpiRequest
     */
    submission_id?: string;
    /**
     * 
     * @type {NpiResponseEnumerationType}
     * @memberof ValidatePalNpiRequest
     */
    npi_type?: NpiResponseEnumerationType;
}

/**
 * Check if a given object implements the ValidatePalNpiRequest interface.
 */
export function instanceOfValidatePalNpiRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "npi" in value;

    return isInstance;
}

export function ValidatePalNpiRequestFromJSON(json: any): ValidatePalNpiRequest {
    return ValidatePalNpiRequestFromJSONTyped(json, false);
}

export function ValidatePalNpiRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePalNpiRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'npi': json['npi'],
        'submission_id': !exists(json, 'submission_id') ? undefined : json['submission_id'],
        'npi_type': !exists(json, 'npi_type') ? undefined : NpiResponseEnumerationTypeFromJSON(json['npi_type']),
    };
}

export function ValidatePalNpiRequestToJSON(value?: ValidatePalNpiRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'npi': value.npi,
        'submission_id': value.submission_id,
        'npi_type': NpiResponseEnumerationTypeToJSON(value.npi_type),
    };
}

